var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weChatIM__panel clearfix"},[_c('div',{staticClass:"we__chatIM-wrapper flexbox flex__direction-column"},[_c('header-bar',{class:{'topfixed': _vm.isTopFixed}}),_vm._v(" "),_c('div',{staticClass:"wcim__container flex1"},[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),_c('tab-bar')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6802a516","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 148
// module chunks = 10